import base from '@/__vue2stone/service/wasaapi/v1/__base';
import time from '@/service/base/time';
import store from '@/store';
import i18n from '@/i18n';
import moment from 'moment';
import systemclass_analysis from './systemclass_analysis';
import H_time from '@/helpers/time';
export default {
  async getLicenseTemplate(factoryId, typeId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      url: `factory/${factoryId}/license_type/${typeId}/license_template`,
      params: _params,
      pagination: true,
    });
    return res;
  },
  async getLicenseTemplateContent(factoryId, licenseTypeId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      url: `factory/${factoryId}/license_template/${licenseTypeId}`,
      params: _params,
    });
    return res;
  },
  async getLicenseList(factoryId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'license',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async getLicenseAllList(factoryId, params) {
    //board calendar
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      get_all: 1,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'license',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async getLicenseAllListV2(params) {
    const currentFactoryId = store.state.app.factory.id;
    const _params = {
      factory: currentFactoryId,
      get_all: 1,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: currentFactoryId,
      modelName: 'license/index/board',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async deleteLicense(factoryId, licenseId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.delete({
      url: `factory/${factoryId}/license/${licenseId}`,
      params: _params,
    });
    return res;
  },
  async getLicenseContent(factoryId, licenseId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      url: `factory/${factoryId}/license/${licenseId}`,
      params: _params,
    });
    return res;
  },
  async updateLicenseContent(factoryId, licenseId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      url: `factory/${factoryId}/license/${licenseId}`,
      data: _data,
    });
    return res;
  },
  async getLicenseVersions(factoryId, licenseId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      url: `factory/${factoryId}/license/${licenseId}/license_version`,
      params: _params,
    });
    return res;
  },
  async create(factoryId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      url: `factory/${factoryId}/license`,
      data: _data,
    });
    return res;
  },
  async createLicenseVersion(factoryId, licenseId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      url: `factory/${factoryId}/license/${licenseId}/license_version`,
      data: _data,
    });
    return res;
  },
  async updateLicenseVersion(factoryId, versionId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      url: `factory/${factoryId}/license_version/${versionId}`,
      data: _data,
    });
    return res;
  },
  async getLicenseType(factoryId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'license_type',
      params: _params,
    });
    return res;
  },
  async getLicenseTypeContent(factoryId, licenseTypeId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      url: `factory/${factoryId}/license_type/${licenseTypeId}`,
      params: _params,
    });
    return res;
  },
  async updateLicenseRemark(factoryId, licenseVersionId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      url: `factory/${factoryId}/license_version/${licenseVersionId}/remark`,
      data: _data,
    });
    return res;
  },
  async licenseExpiredIndex(factoryId, params, type = 'factory') {
    const currentFactory = store.state.app.factory;
    let _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params.organization = currentFactory.id;
      delete _params.factory;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'license/index/expired',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async licenseExpiringIndex(factoryId, params, type = 'factory') {
    const currentFactory = store.state.app.factory;
    let _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params.organization = currentFactory.id;
      delete _params.factory;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'license/index/expiring',
      params: _params,
      pagination: true,
    });
    return res;
  },
  getLicenseExpiredRowData(factoryId, list) {
    if (!list || list.length === 0) return [];
    const _list = list.map((item) => {
      const statusColor = item.last_version.license_status_number === 0 ? 'yellow' : '';
      const statusText = item.last_version.license_status_number === 0 ? '辦理中' : '已核准';
      return {
        id: item.id,
        name: item.name,
        status: {
          color: statusColor,
          text: i18n.t(statusText),
        },
        date: time.getTimeFormat(
          item.last_version.valid_end_date,
          'YYYY-MM-DD',
        ),
        owner: item.last_version.taker
          ? item.last_version.taker
          : { name: '', avatar: '' },
        manager: item.last_version.reminder
          ? item.last_version.reminder
          : { name: '', avatar: '' },
        icon: {
          icon: 'icon-arrow-right',
          path: `/factory/${factoryId}/license-content-main/${item.id}`,
        },
      };
    });
    return _list;
  },
  getLicenseExpiringRowData(factoryId, list) {
    if (!list || list.length === 0) return [];
    const _list = list.map((item) => {
      return {
        id: item.id,
        name: item.name,
        status: {
          color: 'yellow',
          text: i18n.t('辦理中'),
        },
        date: time.getTimeFormat(
          item.last_version.valid_end_date,
          'YYYY-MM-DD',
        ),
        owner: item.last_version.taker
          ? item.last_version.taker
          : { name: '', avatar: '' },
        manager: item.last_version.reminder
          ? item.last_version.reminder
          : { name: '', avatar: '' },
        icon: {
          icon: 'icon-arrow-right',
          path: `/factory/${factoryId}/license-content-main/${item.id}`,
        },
      };
    });
    return _list;
  },
  getLicensePopupFields(licenseTypeId, eventType) {
    let licensePopupFields = {};
    let title =
      eventType === 'remind'
        ? '續辦提醒'
        : eventType === 'extension'
        ? '法定展延'
        : '期限到期';
    if (licenseTypeId === '029b9921-9354-11ee-89b0-42010a8c000b') {
      licensePopupFields = {
        remind: {
          type: 'remind-taker',
          title: i18n.t(`${title}`),
        },
        taker: {
          type: 'text',
          title: i18n.t('持有人'),
        },
        licenseNumber: {
          type: 'text',
          title: i18n.t('證號'),
        },
        validDate: {
          type: 'valid-date',
          title: i18n.t('有效起迄'),
        },
      };
    } else if (licenseTypeId === '029b9ad2-9354-11ee-89b0-42010a8c000b') {
      licensePopupFields = {
        remind: {
          type: 'remind-taker',
          title: i18n.t(`${title}`),
        },
        license_owned_factory: {
          type: 'text',
          title: i18n.t('持有人'),
        },
        licenseNumber: {
          type: 'text',
          title: i18n.t('證號'),
        },
        approvalLetter: {
          type: 'text',
          title: i18n.t('核准函號'),
        },
        validDate: {
          type: 'valid-date',
          title: i18n.t('有效起迄'),
        },
      };
    } else if (licenseTypeId === '029b9b46-9354-11ee-89b0-42010a8c000b') {
      licensePopupFields = {
        remind: {
          type: 'remind-taker',
          title: i18n.t(`${title}`),
        },
        approvalLetter: {
          type: 'text',
          title: i18n.t('核准函號'),
        },
        validDate: {
          type: 'valid-date',
          title: i18n.t('有效起迄'),
        },
        taker: {
          type: 'text',
          title: i18n.t('代理人'),
        },
      };
    } else if (licenseTypeId === '029b9b98-9354-11ee-89b0-42010a8c000b') {
      licensePopupFields = {
        remind: {
          type: 'remind-taker',
          title: i18n.t(`${title}`),
        },
        taker: {
          type: 'text',
          title: i18n.t('持有人'),
        },
        licenseNumber: {
          type: 'text',
          title: i18n.t('證號'),
        },
        approvalLetter: {
          type: 'text',
          title: i18n.t('核准函號'),
        },
        validDate: {
          type: 'valid-date',
          title: i18n.t('有效起迄'),
        },
      };
    } else if (licenseTypeId === '029b9d96-9354-11ee-89b0-42010a8c000b') {
      licensePopupFields = {
        remind: {
          type: 'remind-taker',
          title: i18n.t(`${title}`),
        },
        taker: {
          type: 'text',
          title: i18n.t('持有人'),
        },
        licenseNumber: {
          type: 'text',
          title: i18n.t('證號'),
        },
        validDate: {
          type: 'valid-date',
          title: i18n.t('有效起迄'),
        },
      };
    }
    return licensePopupFields;
  },
  getLicenseCalendarData(item, eventType) {
    let calendarData = {};
    let dataDependedOnEventType = {};
    let date = '';
    if (eventType === 'remind') {
      date = item.last_version.remind_date;
      dataDependedOnEventType = {
        leadingIcon: 'icon-remind-outline',
      };
    } else if (eventType === 'extension') {
      date = item.statitory_extension_date;
      dataDependedOnEventType = {
        leadingIcon: 'icon-extension-outline',
      };
    } else if (eventType === 'expired') {
      date = item.last_version.valid_end_date;
      dataDependedOnEventType = {
        leadingIcon: 'icon-deadline-outline',
      };
    }
    const remind = {
      name: item.last_version.reminder ? item.last_version.reminder.name : '',
      avatarImage: item.last_version.reminder
        ? item.last_version.reminder.avatar
        : '',
      time: date
        ? moment(date)
            .format('YYYY-MM-DD')
        : '',
      ...dataDependedOnEventType,
    };
    const taker = {
      name: item.last_version.taker ? item.last_version.taker.name : '',
      avatarImage: item.last_version.taker
        ? item.last_version.taker.avatar
        : '',
    };
    const licenseNumber = {
      text: item.last_version ? item.last_version.license_number : '',
    };
    const validDate = {
      validStart: item.last_version.valid_start_date
        ? moment(item.last_version.valid_start_date)
            .format('YYYY-MM-DD')
        : '',
      validEnd: item.last_version.valid_end_date
        ? moment(item.last_version.valid_start_date)
            .format('YYYY-MM-DD')
        : '',
    };
    const approvalLetter = {
      text: item.last_version ? item.last_version.approval_letter : '',
    };
    const license_owned_factory = {
      name: store.state.app.factory ? store.state.app.factory.name : '',
    };
    const agent = {
      name: item.last_version.agents[0] ? item.last_version.agents[0].name : '',
      avatar: item.last_version.agents[0]
        ? item.last_version.agents[0].avatar
        : '',
    };
    if (item.license_type.id === '029b9921-9354-11ee-89b0-42010a8c000b') {
      calendarData = {
        remind,
        taker,
        licenseNumber,
        validDate,
        license_type: item.license_type.id,
      };
    } else if (item.license_type.id === '029b9ad2-9354-11ee-89b0-42010a8c000b') {
      calendarData = {
        remind,
        license_owned_factory,
        licenseNumber,
        approvalLetter,
        validDate,
        license_type: item.license_type.id,
      };
    } else if (item.license_type.id === '029b9b46-9354-11ee-89b0-42010a8c000b') {
      calendarData = {
        remind,
        approvalLetter,
        validDate,
        taker: taker.name ? taker : agent,
        license_type: item.license_type.id,
      };
    } else if (item.license_type.id === '029b9b98-9354-11ee-89b0-42010a8c000b') {
      calendarData = {
        remind,
        taker: taker.name ? taker : license_owned_factory,
        licenseNumber,
        approvalLetter,
        validDate,
        license_type: item.license_type.id,
      };
    } else if (item.license_type.id === '029b9d96-9354-11ee-89b0-42010a8c000b') {
      calendarData = {
        remind,
        taker,
        licenseNumber,
        validDate,
        license_type: item.license_type.id,
      };
    }
    return calendarData;
  },
  getCardsData(apiData) {
    apiData = systemclass_analysis.userSystemSubclassesAuthCheck(apiData);
    const result = apiData.filter((card) => {
      return card.last_version;
    });
    let licenseCards = result.map((item) => {
      let name;
      if (item.name) {
        name = item.name;
      } else {
        if (!item.license_template) {
          name = item.name;
        } else {
          name = item.license_template.name;
        }
      }
      let content = [];
      if (item.last_version.license_number) {
        content.push({
          title: i18n.t('證號'),
          text: item.last_version ? item.last_version.license_number : '無',
        });
      }
      if (item.last_version.taker) {
        content.push({
          title: i18n.t('持有人'),
          text: item.last_version ? item.last_version.taker.name : '無',
        });
      }
      if (item.last_version.setup_license) {
        let setupLicense = [
          {
            title: i18n.t('持有人'),
            text: item.last_version.setup_license.last_version.taker
              ? item.last_version.setup_license.last_version.taker.name
              : i18n.t('無'),
          },
          {
            title: i18n.t('證書'),
            text: item.last_version.setup_license.name
              ? item.last_version.setup_license.name
              : item.last_version.setup_license.license_template.name,
          },
        ];
        content = content.concat(setupLicense);
      }
      if (item.last_version.approval_letter) {
        content.push({
          title: i18n.t('核准函號'),
          text: item.last_version ? item.last_version.approval_letter : '無',
        });
      }
      const start = item.last_version && item.last_version.valid_start_date ? H_time.getDateDashFormat(item.last_version.valid_start_date) : i18n.t('無');
      const end = item.last_version && item.last_version.valid_end_date ? H_time.getDateDashFormat(item.last_version.valid_end_date) : i18n.t('無');
      content.push({
        title: i18n.t('效期'),
        text: item.last_version
          ? (item.last_version.valid_end_date || item.last_version.valid_start_date)
          ? `${start} - ${end}`
          : i18n.t('無')
          : i18n.t('無'),
      });
      const hasLicenseOwner = item.license_type.show_fields.some(field => field === 'license_owner');
      const isRetrainingRule = item.license_type.show_fields.some(field => field === 'retraining_rule');
      const setupByLicenseVersions = item.setup_by_license_versions;
      if (hasLicenseOwner && !isRetrainingRule && setupByLicenseVersions) {
        const hasSetupByLicenseVersions = setupByLicenseVersions.length > 0;
        content.push({
          title: i18n.t('屬性'),
          icon: hasSetupByLicenseVersions ? 'icon-check-circle-filled' : '',
          text: hasSetupByLicenseVersions ? i18n.t('本單位報准掛證人員') : i18n.t('非本單位報准掛證人員'),
        });
      }
      if (item.last_version && item.last_version.reminder) {
        content.push({
          title: i18n.t('管理者'),
          icon: '',
          text: item.last_version.reminder.name,
        });
      }
      return {
        id: item.id,
        name: name ? name : i18n.t('其他證照'),
        badges: this.getLicenseCardBadges(item),
        system_subclasses: item.system_subclasses,
        content: content,
        remind: item.last_version
          ? item.last_version.remind_date
          : i18n.t('無'),
        validEnd: item.last_version
          ? item.last_version.valid_end_date
          : i18n.t('無'),
      };
    });
    return licenseCards;
  },
  getLicenseCardBadges(license) {
    let badges = [];
    let badgeFields = this.licenseBadgeFields;
    for (var field in badgeFields) {
      let badge = {};
      if (license.last_version[field] || license.last_version[field] === 0) {
        if (
          badgeFields[field].type === 'date' &&
          this.$_adjustOverdue(license.last_version[field])
        ) {
          badge.text = badgeFields[field].text;
          badge.color = badgeFields[field].color;
          badges.push(badge);
        } else if (
          badgeFields[field].type === 'condition' &&
          parseInt(license.last_version[field]) === 0
        ) {
          badge.text = badgeFields[field].text;
          badge.color = badgeFields[field].color;
          badges.push(badge);
        }
      }
    }
    return badges;
  },
  async tabIndex(params) {
    const currentFactoryId = store.state.app.factory.id;
    const _params = {
      factory: currentFactoryId,
      ...params
    };
    const res = await base.index({
      parentName: 'v1/factory',
      parentId: currentFactoryId,
      modelName: 'license/tab_index',
      params: _params,
    });
    return res;
  },
  async indexAll(params = {}) {
    const currentFactoryId = store.state.app.factory.id;
    const _params = {
      factory: currentFactoryId,
      ...params
    };
    const res = await base.index({
      parentName: 'factory',
      parentId: currentFactoryId,
      modelName: 'license/index/all',
      params: _params,
      pagination: false,
    });
    return res;
  }
};
